// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/PersonalValues.css
// module id = 2129
// module chunks = 0